import Page from '@/interface/ui/search/index';
import {
  appCountryDetermined,
  appLanguageDetermined,
} from '@/store/ducks/app/index';

(Page as any).getInitialProps = ({ query, store }) => {
  const { country, language } = query;
  store.dispatch(appCountryDetermined(country));
  store.dispatch(appLanguageDetermined(language));
  return {
    namespacesRequired: ['common'],
  };
};
export default Page;
